import DialogTextField from './DialogTextField';
import DialogItemsField from './DialogItemsField';
import DialogNumberField from './DialogNumberField';
import DialogSelectField from './DialogSelectField';
import DialogCheckboxField from './DialogCheckboxField';
import DialogUploadField from './DialogUploadField';
import DialogStateField from './DialogStateField';
import DialogPhoneField from './DialogPhoneField';
import DialogPercentField from './DialogPercentField';
import DialogAmountField from './DialogAmountField';
import DialogDateField from './DialogDateField';
import Dialog2FAField from './Dialog2FAField';
import DialogEnableField from './DialogEnableField';
import DialogCryptoAmountField from './DialogCryptoAmountField';
import DialogCommissionsField from './DialogCommissionsField';
import EditorSelectField from './EditorSelectField';
import { DialogEntityField } from './DialogEntityField';
import DialogServerSearchField from './DialogServerSearchField';
import DialogSystemRoleField from './DialogSystemRoleField';
import DialogContextMultiSelect from './DialogContextMultiSelect';
import DialogRoleSelectField from './DialogRoleSelectField';
import DialogBigTextField from './DialogBigTextField';
import DialogDateTimeField from './DialogDateTimeField';
import DialogStaticMultiSelect from './DialogStaticMultiSelect';
import DialogBalanceField from './DialogBalanceField';
import DialogTagsField from './DialogTagsField';
import DialogJsonField from './DialogJsonField';
// import DialogItemsControllers from './DialogItemsControllers';
// import DialogRulesField from './DialogRulesField';

const Fields = {
    Text: DialogTextField,
    Items: DialogItemsField,
    State: DialogStateField,
    Number: DialogNumberField,
    Select: DialogSelectField,
    Checkbox: DialogCheckboxField,
    Upload: DialogUploadField,
    Phone: DialogPhoneField,
    Percent: DialogPercentField,
    Amount: DialogAmountField,
    Date: DialogDateField,
    DateTime: DialogDateTimeField,
    Dialog2FA: Dialog2FAField,
    Enable: DialogEnableField,
    CryptoAmount: DialogCryptoAmountField,
    CommissionsTotal: DialogCommissionsField,
    EditorSelect: EditorSelectField,
    Entity: DialogEntityField,
    ServerSearch: DialogServerSearchField,
    SystemRole: DialogSystemRoleField,
    SelectCombined: DialogSelectField,
    ContextMultiSelect: DialogContextMultiSelect,
    StaticMultiSelect: DialogStaticMultiSelect,
    EditableBoolean: DialogCheckboxField,
    RoleSelect: DialogRoleSelectField,
    BigText: DialogBigTextField,
    Balance: DialogBalanceField,
    Tags: DialogTagsField,
    Json: DialogJsonField,
    // ItemsControllers: DialogItemsControllers
};

export default Fields;
